module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('div', [_c('section', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "user-panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('p', [_vm._v("Good Job,")]), _vm._v(" "), _c('p', [_c('small', [_vm._v(_vm._s(_vm.user.email))])]), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'logout'
      }
    }
  }, [_c('i', {
    staticClass: "ti-power-off"
  }), _vm._v(" "), _c('small', [_vm._v("Logout")])])], 1)]), _vm._v(" "), _c('img', {
    staticClass: "bg-user",
    attrs: {
      "src": "/static/img/avatar-bg.png",
      "alt": "User Image"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'devices'
      }
    }
  }, [_c('i', {
    staticClass: "ti-desktop"
  }), _vm._v(" "), _c('span', [_vm._v("Devices")])])], 1), _vm._v(" "), (_vm.isAdmin) ? [_c('li', {
    staticClass: "header"
  }, [_vm._v("ADMIN")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'customers'
      }
    }
  }, [_c('i', {
    staticClass: "ti-crown"
  }), _vm._v(" "), _c('span', [_vm._v("Customers")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'users'
      }
    }
  }, [_c('i', {
    staticClass: "ti-user"
  }), _vm._v(" "), _c('span', [_vm._v("Users")])])], 1)] : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": "/static/img/avatar2.png",
      "alt": "User Image"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b22dd83e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Sidebar.vue
// module id = 1166
// module chunks = 2